import React, { Component } from 'react';
import { Outlet } from 'react-router';
import { Container } from 'reactstrap';
// import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  constructor(props) {
    super(props);

    //console.log('props', props, this)
  }

  render () {
    return (
      <div>
        {/* <NavMenu /> */}
        <Container>
          <Outlet />
        </Container>
      </div>
    );
  }
}
